import Avvir from "avvir";
import IntegrationIssueTracker from "../../models/api/integration_table_issues";
import { AvvirThunk } from "../make_eventful_action";
import { AvvirEvent } from "type_aliases";

export const SET_ANNOTATION_INTEGRATION_ISSUES = 'SET_ANNOTATION_INTEGRATION_ISSUES';

export type SetAnnotationIntegrationIssuesEvent = AvvirEvent<
  typeof SET_ANNOTATION_INTEGRATION_ISSUES,
  IntegrationIssueTracker[]
>;

const getAllIntegrationPushedIssuesForElements = (projectId, firebaseFloorId, globalIds: string[]): AvvirThunk<Promise<IntegrationIssueTracker[] | void>, SetAnnotationIntegrationIssuesEvent> => {
  return async (dispatch, getState) => {
    const { user } = getState();
    const ids = globalIds.map(id => ({
      pbeProjectId: projectId,
      firebaseFloorId,
      globalId: id,
    }));
    try {
      const rawRes = await Avvir.api.integrations.getAllCreatedIssuesForDeviatedElements(user, ids);
      const res: IntegrationIssueTracker[] = rawRes as unknown as IntegrationIssueTracker[];
      dispatch({ type: 'SET_ANNOTATION_INTEGRATION_ISSUES', payload: res });
      return res;
    } catch (error) {
      console.error("Error getting issues for selected Elements", error);
    }
  };
};

export default getAllIntegrationPushedIssuesForElements;